import Logger from '../util/Logger';
import _ from 'lodash';
import { collectionTypeFromString } from './CollectionTypes';

export default {

  /**
   * Get the id
   * @param collection
   * @returns {string} Collection id
   */
  getId (collection) {
    if (!collection) {
      Logger.assert('Must pass a collection object');
    } else {
      const id = _.get(collection, 'id');
      if (!id) {
        Logger.assert('Collection was missing id');
      } else {
        return id;
      }
    }
  },

  getName (collection) {
    if (!collection) {
      Logger.assert('Cannot call getName() without a Collection object');
    } else {
      return _.get(collection, 'name') || '';
    }
  },

  getShortCode (collection ) {
    if (!collection) {
      Logger.assert('Cannot call getName() without a Collection object');
    } else {
      return _.get(collection, 'short_code') || '';
    }
  },

  getEvents (collection) {
    if (!collection) {
      Logger.assert('Cannot call getEvents() without a Collection object');
    } else {
      const events = _.get(collection, 'events') || [];
      if (!events || events.length === 0) {
        Logger.error('Collection was missing events', this.getId(collection));
        return [];
      } else {
        return events;
      }
    }
  },

  getEventCount (collection) {
    if (!collection) {
      Logger.assert('Cannot call getEventCount() without a Collection object');
    } else {
      return _.get(collection, 'events_count') || 0;
    }
  },

  /**
   * Extracts the collection type
   *
   * @param {object} collection Collection Json
   * @returns {string|null} collection type
   */
  getType (collection) {
    if (!collection) {
      Logger.assert('Cannot call getType() without a Collection object');
    } else {
      const type = _.get(collection, 'type');
      if (!type) {
        Logger.error('Collection was missing type', this.getId(collection));
        return null;
      } else {
        return collectionTypeFromString(type);
      }
    }
  },

  isRepeating (collection) {
    if (!collection) {
      Logger.assert('Cannot call isRepeating() without a Collection object');
    } else {
      return _.get(collection, 'recurrence_setting') || false;
    }
  },

  /**
   * Extracts the collection phase
   *
   * @param collection
   * @returns {*|boolean}
   */
  getPhase (collection) {
    if (!collection) {
      Logger.assert('Cannot call getPhase() without a Collection object');
    } else {
      return _.get(collection, 'phase') || 'NA';
    }
  },

  isConcurrentEnabled (collection) {
    if (!collection) {
      Logger.assert('Cannot call isConcurrentEnabled() without a Collection object');
    } else {
      return _.get(collection, 'concurrent_enabled') || false;
    }
  }
};
